import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { BaseIcon } from "../base-icon";
export var CompareIcon = function(_param) /*#__PURE__*/ {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 24 : _size, props = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    return _jsx(BaseIcon, _object_spread_props(_object_spread({}, props), {
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12ZM8.471 4.195c.26.26.26.683 0 .943L6.276 7.333h13.057a.667.667 0 1 1 0 1.334H6.276l2.195 2.195a.667.667 0 0 1-.942.943L4.195 8.47a.667.667 0 0 1 0-.942L7.53 4.195c.26-.26.682-.26.942 0Zm7.058 15.61a.667.667 0 0 1 0-.943l2.195-2.195H4.667a.667.667 0 1 1 0-1.334h13.057l-2.195-2.195a.667.667 0 0 1 .942-.943l3.334 3.334a.667.667 0 0 1 0 .942l-3.334 3.334a.667.667 0 0 1-.942 0Z",
            clipRule: "evenodd"
        })
    }));
};
